(function ($) {
  function resetParsley($select) {
    $select.find("select").parsley().reset({ force: true });
    $select.find("select").parsley().validate({ force: true });
  }

  // function resetNiceSelect() {
  //    $('.powermail_select').niceSelect('destroy');
  //    $('.powermail_select.nice-select').remove();
  //    $('.powermail_select').niceSelect();
  // }

  // unbind and bind click of nice-select to a grouped validation
  function bindSelects() {
    $(".powermail_morestep .nice-select.powermail_select .list .option").off();
    $(".powermail_morestep .nice-select.powermail_select .list .option").on(
      "click",
      function (e) {
        var value = $(this).data("value");
        var $select = $(this).parents(".powermail_fieldwrap_type_select");
        if ($select.find('select option[value="' + value + '"]').length > 0) {
          $select.find("select option").removeAttr("selected");
          $select
            .find('select option[value="' + value + '"]')
            .attr("selected", "");
          resetParsley($select);
        }
      }
    );
  }

  // add debounce and a different trigger to input-fields
  function debounceInputFields() {
    var $form = $(".powermail_form");
    $form.find("input").attr("data-parsley-trigger", "change");
    $form.find("input").attr("data-parsley-debounce", "1000");
    // $form.parsley().refresh();
  }

  function matchHeightSimple(elem) {
    var heights = elem
      .map(function () {
        return $(this).height();
      })
      .get();

    var maxHeight = Math.max.apply(null, heights);

    elem.height(maxHeight);
  }

  // DOM ready
  $(function () {
    if (
      typeof $("#datepicker1") != "undefined" &&
      $("#datepicker1").length > 0
    ) {
      $("#datepicker1").datepicker({
        dateFormat: "dd.mm.yy",
        altField: "#datepicker_actualdate1",
        altFormat: "yy-mm-dd",
      });
    }
    if (
      typeof $("#datepicker2") != "undefined" &&
      $("#datepicker2").length > 0
    ) {
      $("#datepicker2").datepicker({
        dateFormat: "dd.mm.yy",
        altField: "#datepicker_actualdate2",
        altFormat: "yy-mm-dd",
      });
    }

    function checkSlider() {
      var $slide = $('.main-carousel__slide .slide-photo[data-js="cover-img"]');
      if ($(window).width() < 1200) {
        $slide.css("background-position-x", "0%");
      } else {
        $slide.css("background-position-x", "50%");
      }
    }

    function iframeEmbed() {
      $(".embed-responsive.embed-responsive-16by9").each(function () {
        var $this = $(this);
        $this.css("opacity", 0);
        setTimeout(function () {
          $this.html($this.data("iframe"));
          setTimeout(function () {
            $this.css("opacity", 1);
          }, 300);
        }, 300);
      });
    }

    var buttonsContainer = $(".socials-list");
    if (buttonsContainer.length > 0) {
      new Shariff(buttonsContainer, {
        // theme: "default",
        services: ["facebook", "twitter"],
        // orientation: "horizontal",
        // lang: "de"
      });
    }

    // Teasers match height
    if (
      document.querySelector(".grid-25-25-25-25") ||
      document.querySelector(".grid-33-33-33") ||
      document.querySelector(".grid-50-50")
    ) {
      $(
        ".grid-25-25-25-25 > .container, .grid-33-33-33 > .container, .grid-50-50 > .container"
      ).each(function () {
        // the containers for all your galleries
        $(this).find(" .teaser_10").matchHeight({
          byRow: false,
          property: "height",
        });
      });

      $(".grid-25-25-25-25 .col-lg-3").each(function () {
        if (!$(this).children().length) {
          this.className += " d-sm-none d-lg-block";
          $(this).removeClass("mb-md-5");
        } else {
          this.className += " mb-4 mb-lg-5";
          $(this).removeClass("mb-md-5");
        }
      });
    }

    // Teasers match height
    $(".ctype-ce_link .btn.btn_grey").matchHeight({
      // byRow: true,
      property: "height",
    });

    // Carousel match height
    $(".content-carousel .slide-caption").matchHeight({
      byRow: true,
      property: "height",
    });

    // Text-Media in grid-50-50
    $(".grid-50-50 .ce-textpic .ce-text").matchHeight({
      property: "height",
    });

    // Team-Element in grid-50-50
    if (document.querySelector(".grid-50-50 .team-item")) {
      $(".grid-50-50 .team-item").matchHeight({
        property: "height",
      });

      if (window.innerWidth > 991 && $(".left").length) {
        matchHeightSimple($(".left").parent().find(".klinik-line__title"));
      }
    }

    // Button-Links match height
    $(".grid-33-33-33 .ctype-ce_button_teaser .btn").matchHeight({
      // byRow: false,
      property: "height",
    });

    // Icon-Links match height
    $(".link-button > a").matchHeight({
      // byRow: false,
      property: "height",
    });

    // coverImage();
    checkSlider();

    setTimeout(function () {
      iframeEmbed();
    }, 1000);

    // Service navigation search button
    $(".service-nav__search-btn").on("click", function (e) {
      if ($(".service-nav__search-field").val().length < 3) {
        e.preventDefault();
        $(this).toggleClass("active");
        if ($(this).hasClass("active")) {
          $(".service-nav__search-field").trigger("focus");
        } else {
          $(".service-nav__search-field").trigger("focusout");
        }
      } else {
        $(this).parent().find("form").submit();
      }
    });
    $(".service-nav__search-field").on("focusout", function () {
      $(".service-nav__search-btn").removeClass("active");
    });

    // Burger button
    $(".btn_burger").on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("clicked");
      $(".header__main-nav-panel").toggleClass("shown");
      $(".header__main-nav-panel [class*=collapse-]").removeClass("active");
      $(".header__main-nav-panel [class*=collapsible-]").removeClass("show");
      if ($(".btn_burger").hasClass("clicked")) {
        $(".header__main-nav-panel .selected").removeClass("selected");
        $(".header__main-nav-panel a").removeClass("shown");
        $(".header__main-nav-panel div").removeClass("show");
        $(".header__main-nav > li > a").removeAttr("tabindex");
        $(".header-mobil__service-nav a").removeAttr("tabindex");
      } else {
        $(".header__main-nav > li > a").attr("tabindex", "-1");
        $(".header-mobil__service-nav a").attr("tabindex", "-1");
      }
    });

    $(window).on("resize", function (e) {
      if (!e.isTrigger) {
        clearTimeout(this._timer);

        this._timer = setTimeout(function () {
          if (window.outerWidth > 991) {
            $(".header__main-nav > li > a").removeAttr("tabindex");
            $(".header-mobil__service-nav a").removeAttr("tabindex");
          } else {
            $(".header__main-nav > li > a").attr("tabindex", "-1");
            $(".header-mobil__service-nav a").attr("tabindex", "-1");
          }

          if (window.innerWidth > 991) {
            initInlineGalleries($(".ctype-gridelements_pi1 .gallery"), true);
          }
        });
      }
    });

    // Styled options of select-regions
    if ($(".b-select-region .nice-select").length > 0) {
      $(".b-select-region .nice-select").niceSelect();
    }

    // Custom scroll block replacement
    $(".mCSB_buttonUp").on("click", function (e) {
      var y = $(".mCustomScrollBox").scrollTop(); // current page position
      $(".mCustomScrollBox").animate({ scrollTop: y - 150 }, 500);
    });

    $(".mCSB_buttonDown").on("click", function (e) {
      var y = $(".mCustomScrollBox").scrollTop(); // current page position
      $(".mCustomScrollBox").animate({ scrollTop: y + 150 }, 500);
    });

    // Button toggle content
    $(".content-line.long-content-section.more-content-panel").each(
      function () {
        $(this)
          .find(".btn_toggle-content")
          .on("click", function (e) {
            e.preventDefault();
            var $this = $(this).parents(
              ".content-line.long-content-section.more-content-panel"
            );
            $this.find(".long-content-section__line").fadeToggle(300);
            $this
              .find(".btn_toggle-content")
              .toggleClass("clicked")
              .find("span")
              .toggle();
            if ($this.find(".btn_toggle-content").not(".clicked").length > 0) {
              $("html, body").animate(
                { scrollTop: $this.offset().top - 50 },
                500
              );
            }
            setTimeout(function () {
              if (typeof slick !== "undefined") {
                $this.find(".content-carousel").slick("refresh");
              }
              // Teasers match height
              $this.find(".content-carousel .slide-caption").matchHeight({
                byRow: true,
                property: "height",
              });
            }, 300);
          });
      }
    );

    if ($(window).width() < 992) {
      $(
        ".header__main-nav-panel [class*=collapsible-], .header__main-nav-panel .special-flyout"
      ).addClass("collapse");
    } else {
      $(".header__main-nav-panel [class*=collapsible-]").removeClass(
        "collapse"
      );
    }

    $(".header__main-nav-panel [class*=collapse-]").on("click", function (e) {
      if ($(window).width() < 992) {
        if ($(e.target).hasClass("show")) {
          $(this).trigger("click");
        } else {
          e.preventDefault();
          $(
            ".header__main-nav-panel .collapse.show .special-flyout.show"
          ).removeClass("show");
          $(".header__main-nav-panel .collapse.show").removeClass("show");
          $(".header__main-nav-panel [class*=collapse-]").removeClass("show");
          $(e.target).addClass("show");
          $(e.target).next(".collapse, .special-flyout").addClass("show");
        }
      } else {
        $(
          ".header__main-nav-panel .collapse.show .special-flyout.show"
        ).removeClass("show");
        $(".header__main-nav-panel .collapse.show").removeClass("show");
      }
    });

    if (document.body.classList.contains("location")) {
      $(".main-carousel__slide").each(function () {
        var bannerDescElem = this.querySelector(".slide-desc");
        var bannerText = bannerDescElem.innerText;
        var isBannerTextLong = bannerText.split(" ").some(function (word) {
          return word.length > 9;
        });
        var bannerDescCalss = isBannerTextLong
          ? "slide-desc slide-desc--wide"
          : "slide-desc";

        $(bannerDescElem).removeClass("slide-desc");
        bannerDescElem.innerHTML =
          '<div class="container"><div class="row"><div class="col-12"><div class="' +
          bannerDescCalss +
          ' fade show"><h1><strong>' +
          bannerText +
          "</strong></h1></div></div></div></div>";
      });
    }

    // Scroll top button
    $(".btn_up").on("click", function (e) {
      e.preventDefault();
      $("body, html").animate(
        {
          scrollTop: 0,
        },
        600
      );
    });

    // Panel
    $(".b-panel__title").on("click", function (e) {
      e.preventDefault();
      var $this = $(this);
      var $accordion = $this.parents(".ctype-ce_accordion_inline");
      var $klapper = $this.parents(".klapper");
      var $klapperrss = $this.parents(".klapperrss");
      if ($accordion.length > 0) {
        if ($this.hasClass("clicked")) {
          $accordion.find(".b-panel__title").removeClass("clicked");
        } else {
          $accordion.find(".b-panel__title").removeClass("clicked");
          $this.addClass("clicked");
        }
      } else if ($klapper.length > 0) {
        if ($this.hasClass("clicked")) {
          $(".klapper .b-panel__title").removeClass("clicked");
        } else {
          $(".klapper .b-panel__title").removeClass("clicked");
          $this.addClass("clicked");
          setTimeout(function () {
            $("html, body")
              .stop()
              .animate({ scrollTop: $klapper.offset().top - 10 }, "slow");
          }, 400);
        }
      } else if ($klapperrss.length > 0) {
        if ($this.hasClass("clicked")) {
          $(".klapperrss .b-panel__title").removeClass("clicked");
        } else {
          $(".klapperrss .b-panel__title").removeClass("clicked");
          $this.addClass("clicked");
          setTimeout(function () {
            $("html, body")
              .stop()
              .animate({ scrollTop: $klapperrss.offset().top - 10 }, "slow");
          }, 400);
        }
      }
    });

    // List with arrow
    $(".list-with-arrow > ul > li").on("click", function (e) {
      if (!$(e.target).closest(".c-childs").length) {
        e.preventDefault();
        $(this).toggleClass("active").find("ul").slideToggle(300);
      }
    });

    // Select
    if ($(".rexx_integration").length < 1) {
      // $('select').not('.tx-powermail select').niceSelect();
    } else {
      var rexxCounter = 10;
      var timerId = setTimeout(function tick() {
        $('[rel="shortcut icon"]').attr(
          "href",
          "/typo3conf/ext/as_template/Resources/Public/Images/favicon.ico"
        );
        if (rexxCounter > 1) {
          timerId = setTimeout(tick, 1000);
        }
        rexxCounter -= 1;
      }, 1000);
    }

    // -------------- Body map --------------
    var textRightArrow = $(".circle.dynamic + p").text();
    var toggle = false;
    $("img[usemap]").rwdImageMaps();
    $("img[usemap]").after(createSvg());

    function createSvg() {
      var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      var polygonPath = "";
      var shapesCount = $(".main-shape").length;
      var markersCount = [
        $("a.marker-women").length,
        $("a.marker-boy").length,
        $("a.marker-men").length,
      ];
      var classes = ["women", "boy", "men"];

      $(svg).css({
        width: $("img[usemap]").width(),
        height: $("img[usemap]").height(),
      });
      $(svg).attr("viewBox", "0 0 1920 1920");
      $(svg).addClass("img-svg");

      $(window).on("resize", function () {
        $(".img-svg").css({
          width: $("img[usemap]").width(),
          height: $("img[usemap]").height(),
        });
        if ($(window).width() < 992) {
          $(".header__main-nav-panel [class*=collapsible-]").addClass(
            "collapse"
          );
        } else {
          $(".header__main-nav-panel [class*=collapsible-]").removeClass(
            "collapse"
          );
        }
        checkSlider();
      });

      for (var i = 0; i < shapesCount; i++) {
        var polygon = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "polygon"
        );
        var path = $(".main-shape").eq(i).attr("coords").split(",");
        polygonPath = "";
        for (var j = 0; j < path.length - 2; j += 2) {
          polygonPath += path[j] + "," + path[j + 1] + " ";
        }
        $(polygon).attr("points", polygonPath);
        $(polygon).addClass(classes[i]);
        $(svg).append($(polygon));

        createMarkers(svg, i, markersCount[i], classes);
      }
      return svg;
    }

    function createMarkers(svgOb, start, end, classNames) {
      for (var k = 0; k < end; k++) {
        var group = document.createElementNS("http://www.w3.org/2000/svg", "g");
        var circle = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "circle"
        );
        var innerCircle = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "circle"
        );
        $(group).addClass("marker " + "marker-" + classNames[start]);
        $(group).attr(
          "data-target",
          $("a.marker-" + classNames[start])
            .eq(k)
            .attr("data-target")
        );
        $(group).attr(
          "data-ids",
          $("a.marker-" + classNames[start])
            .eq(k)
            .attr("data-ids")
        );
        $(group).attr(
          "data-alt",
          $("a.marker-" + classNames[start])
            .eq(k)
            .attr("data-alt")
        );
        $(circle).attr(
          "cx",
          $("a.marker-" + classNames[start])
            .eq(k)
            .attr("data-left")
        );
        $(circle).attr(
          "cy",
          $("a.marker-" + classNames[start])
            .eq(k)
            .attr("data-top")
        );
        $(circle).attr("r", "20");
        $(circle).attr("fill", "#318ce0");
        $(innerCircle).attr(
          "cx",
          $("a.marker-" + classNames[start])
            .eq(k)
            .attr("data-left")
        );
        $(innerCircle).attr(
          "cy",
          $("a.marker-" + classNames[start])
            .eq(k)
            .attr("data-top")
        );
        $(innerCircle).attr("r", "12");
        $(innerCircle).attr("stroke-width", "4");
        $(innerCircle).attr("stroke", "#ffffff");
        $(innerCircle).attr("fill", "transparent");
        $(group).append($(circle));
        $(group).append($(innerCircle));
        $(svgOb).append($(group));
      }
    }

    function createPopup(text) {
      var popupWraper = document.createElement("div");
      $(popupWraper).addClass("body-map-popup");
      var popupText = document.createElement("p");
      $(popupText).text(text);
      $(popupWraper).append($(popupText));
      $("body").append($(popupWraper));
    }

    function removePopup() {
      $(".body-map-popup").remove();
    }

    $("polygon").on("mouseover", function () {
      var selector = $(this).attr("class");
      $(".marker-" + selector).css({
        opacity: "1",
      });
    });
    $("polygon").on("mouseleave", function () {
      $(".marker").attr("style", "");
      if ($(".img-svg").hasClass("active")) {
        var selector = "";
        if ($(".marker.active").hasClass("marker-women")) {
          selector = ".marker-women";
        } else if ($(".marker.active").hasClass("marker-boy")) {
          selector = ".marker-boy";
        } else {
          selector = ".marker-men";
        }
        $(selector).css({
          opacity: "1",
        });
      }
    });

    $(".marker").on("mouseenter", function () {
      var markerType = "";
      if ($(this).hasClass("marker-women")) {
        markerType = "women";
      } else if ($(this).hasClass("marker-boy")) {
        markerType = "boy";
      } else {
        markerType = "men";
      }
      $("polygon." + markerType).css({
        fill: "rgba(49,140,224, 0)",
      });
      $(".marker-" + markerType).css({
        opacity: ".5",
      });
      $(this).css({
        opacity: "1",
      });
      $(".circle.dynamic + p").text($(this).attr("data-target"));
      createPopup($(this).attr("data-alt"));
      $(".body-map-popup").css({
        top: $(this).offset().top - 10,
        left: $(this).offset().left + 30,
      });
    });

    $(".marker").on("mouseleave", function () {
      removePopup();
    });

    $(".marker").on("click", function () {
      $(".body-map__list > li.first").remove();
      $(".marker").removeClass("active");
      $(this).addClass("active");
      var ids = $(this).attr("data-ids").split(",");
      $(".body-map__list > li").removeClass("current").fadeOut(300);
      setTimeout(function () {
        for (var i = 0; i < ids.length; i++) {
          $(".body-map__list > li > a#" + ids[i])
            .parent()
            .fadeIn(300);
        }
      }, 300);
    });

    $(".body-map__list > li > a").on("click", function (e) {
      e.preventDefault();
      $(".body-map__list > li").removeClass("current");
      $(this).parent().addClass("current");
    });
    // --------------------------------------

    // Carousels
    const sliders = [
      document.querySelectorAll(".content-carousel .slider-wrapper"),
      document.querySelector(".main-carousel .slider-wrapper"),
      document.querySelector(".team-carousel .slider-wrapper"),
    ];

    // Content carousel
    if (sliders[0]) {
      sliders[0].forEach(function (elem) {
        $(elem)
          .find(".content-carousel__slide")
          .each(function (index) {
            $(this)
              .find(".slide-number")
              .text(
                ++index +
                  " / " +
                  $(".content-carousel .content-carousel__slide").length
              );
          });

        $(elem).on("init", function (event, slick) {
          $(event.target).addClass("init");
        });

        $(elem).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          prevArrow:
            '<a href="#" class="content-carousel__arr content-carousel__arr_prev">',
          nextArrow:
            '<a href="#" class="content-carousel__arr content-carousel__arr_next">',
          draggable: false,
          cssEase: "ease-in-out",
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                draggable: true,
                arrows: false,
                autoplay: false,
                autoplaySpeed: 4000,
              },
            },
          ],
        });
      });
    }

    $(sliders[0])
      .closest(".content-carousel")
      .find(".slider-toggle")
      .on("click", function (e) {
        var $parent = $(e.target).parents(".content-carousel");
        if ($(e.target).hasClass("pause-btn")) {
          $parent.find(".slider-wrapper").slick("slickPause");
          $(e.target).removeClass("pause-btn").addClass("play-btn").focus();
        } else {
          $parent.find(".slider-wrapper").slick("slickPlay");
          $(e.target).removeClass("play-btn").addClass("pause-btn").focus();
        }
      });

    // Main carousel
    if (sliders[1]) {
      if ($(sliders[1]).children().length > 1) {
        $(sliders[1]).on("init", function (event, slick) {
          $(event.target).addClass("init");
        });

        $(sliders[1]).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          prevArrow:
            '<a href="#" class="main-carousel__arr main-carousel__arr_prev">',
          nextArrow:
            '<a href="#" class="main-carousel__arr main-carousel__arr_next">',
          draggable: false,
          speed: 1000,
          cssEase: "ease-in-out",
          autoplay: true,
          autoplaySpeed: 5000,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                draggable: true,
                arrows: false,
              },
            },
          ],
        });

        $(sliders[1])
          .closest(".main-carousel")
          .find(".slider-toggle")
          .on("click", function (e) {
            var $parent = $(e.target).parents(".main-carousel");
            if ($(e.target).hasClass("pause-btn")) {
              $parent.find(".slider-wrapper").slick("slickPause");
              $(e.target).removeClass("pause-btn").addClass("play-btn").focus();
            } else {
              $parent.find(".slider-wrapper").slick("slickPlay");
              $(e.target).removeClass("play-btn").addClass("pause-btn").focus();
            }
          });
      } else {
        $(sliders[1]).parent().find(".pause-btn").remove();
      }
    }

    // Team carousel
    if (sliders[2]) {
      if ($(sliders[2]).children().length > 2) {
        $(sliders[2]).on("init", function (event, slick) {
          $(event.target).addClass("init");
        });

        $(sliders[2]).slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          prevArrow:
            '<a href="#" class="content-carousel__arr content-carousel__arr_prev">',
          nextArrow:
            '<a href="#" class="content-carousel__arr content-carousel__arr_next">',
          draggable: false,
          responsive: [
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 3,
                draggable: true,
              },
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
      } else {
        $(sliders[2]).addClass("d-sm-flex");
        $(sliders[2])
          .closest(".team-carousel")
          .addClass("team-carousel--columns");
        $(sliders[2]).closest(".ctype-ce_contact").removeClass("bg-color-25");
      }
    }

    $(".img-svg").css({
      width: $("img[usemap]").width(),
      height: $("img[usemap]").height(),
    });

    if ($(".powermail_form") && $(".powermail_form").length > 0) {
      $(document).ready(function () {
        let $morestep = $(".powermail_morestep");

        if ($morestep.length > 0) {
          $(".powermail_morestep").each(function () {
            $(this)
              .find(".powermail_fieldset")
              .each(function (index) {
                $(this).addClass("fs" + index);
              });
          });
        }

        // powermail-helper
        // $form.parsley().refresh();
        // resetNiceSelect();
        debounceInputFields();
        bindSelects();

        window.Parsley.on("form:error", function (e) {
          $(".powermail_form .powermail_fieldwrap").each(function (index) {
            $(this)
              .find(".parsley-errors-list")
              .appendTo($(this).find(".powermail_field"));
          });
          if ($morestep.length > 0) {
            let firstOffender = $(".powermail_form .powermail_fieldwrap")
              .find(".parsley-errors-list")
              .get(0);
            let index = $(firstOffender)
              .parents(".powermail_fieldset")
              .attr("class")
              .match(/fs[\w-]*\b/)[0]
              .slice(-1);
            $(firstOffender)
              .parents(".powermail_morestep")
              .find(".item" + index)
              .trigger("click");
            if (
              $(firstOffender).parents(".powermail_field").find("input")
                .length > 0
            ) {
              $(firstOffender)
                .parents(".powermail_field")
                .find("input")[0]
                .focus();
            }
            if (
              $(firstOffender).parents(".powermail_field").find("select")
                .length > 0
            ) {
              $(firstOffender)
                .parents(".powermail_field")
                .find("select")[0]
                .focus();
            }
          }
        });
      });
    }
  });

  // VideoJS
  $(".video-js").each(function (index) {
    var id = $(this).attr("id");
    var player = videojs(id, {
      fluid: true,
      aspectRatio: "9:16",
      nativeControlsForTouch: true,
    });

    player.fill(true);
    player.addChild("BigPlayButton");

    if ($(this).parents(".modal")) {
      $(this)
        .parents(".modal")
        .on("show.bs.modal", function () {
          player.play();
        });
      $(this)
        .parents(".modal")
        .on("hide.bs.modal", function () {
          player.pause();
        });
    }
  });

  if (
    typeof $(".klinik-search-block input") != "undefined" &&
    $(".klinik-search-block input").length > 0
  ) {
    $(".klinik-search-block input").keyup(function () {
      var search = $(this).val();
      var hits;

      function fadeParent(obj) {
        var parent = obj.parents(".klinik-line");

        if (parent.find(".team-item:visible").length == 0) {
          parent.find(".klinik-line__title").fadeOut();
          parent.css("margin-top", 0);
        } else {
          parent.find(".klinik-line__title").fadeIn();
          parent.css("margin-top", "");
        }
      }

      if (search.length == 0) {
        hits = $(this)
          .parents(".klinik-search-block")
          .parent()
          .find(".team-item");
        hits.fadeIn(400, function () {
          fadeParent($(this));
        });

        return;
      }

      var hits = $(this)
        .parents(".klinik-search-block")
        .parent()
        .find(".info:Contains('" + search + "')")
        .parents(".team-item");
      var misses = $(this)
        .parents(".klinik-search-block")
        .parent()
        .find(".info:not(:Contains('" + search + "'))")
        .parents(".team-item");

      hits.fadeIn(400, function () {
        fadeParent($(this));
      });
      misses.fadeOut(400, function () {
        fadeParent($(this));
      });
    });
  }

  /*
   * MagnificPopup Einzelbild und Galerie für Text & Medien
   */
  $("a.lightbox").magnificPopup({
    type: "image",
    closeOnContentClick: true,
    tLoading: "Loading image #%curr%...",
    mainClass: "mfp-img-mobile",
    gallery: {
      enabled: true,
    },
    image: {
      titleSrc: function (item) {
        var title = "";
        var img = item.el.find("img");
        var a_title = img.attr("title");
        if (typeof a_title != "undefined" && a_title.length > 0) {
          title = a_title;
        }
        if (img.length > 0 && img.attr("data-description")) {
          title += " - " + img.attr("data-description");
        }
        return title;
      },
    },
  });

  /*
   * To have multiple galleries on a page, you need to create a new instance of Magnific Popup for each separate gallery.
   */

  // Will stop on the first found Element
  function initInlineGalleries(items, reset) {
    if (!items.length) {
      return;
    }

    var galleriesCentered = [];
    var maxGalleryHeight = 0;

    if (reset) {
      items.removeAttr("style");
    }

    setTimeout(
      function () {
        items.each(function () {
          var itemClassName =
            items.closest("section")[0].parentElement.className;

          // Check if there are more then 1 cols
          if (
            itemClassName.indexOf("col") !== itemClassName.lastIndexOf("col")
          ) {
            galleriesCentered.push($(this));

            if ($(this).height() > maxGalleryHeight) {
              maxGalleryHeight = $(this).height();
            }
          }
        });

        $.each(galleriesCentered, function () {
          $(this).height(maxGalleryHeight);
        });
      },
      reset ? 500 : 0
    );
  }

  if (document.querySelector("section .gallery")) {
    initInlineGalleries($(".ctype-gridelements_pi1 .gallery"));

    $("section .gallery:not(.logo-gallery)").each(function () {
      $(this).magnificPopup({
        delegate: "a",
        type: "image",
        closeOnContentClick: true,
        tLoading: "Loading image #%curr%...",
        mainClass: "mfp-img-mobile",
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          arrowMarkup:
            '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
          tPrev: "Vorheriges Bild",
          tNext: "Nächstes Bild",
          tCounter: '<span class="mfp-counter">%curr% of %total%</span>',
        },
        image: {
          titleSrc: function (item) {
            var title = "";
            var img = item.el.find("img");
            var a_title = img.attr("title");
            if (typeof a_title != "undefined" && a_title.length > 0) {
              title = a_title + " ";
            }
            if (img.length > 0 && img.attr("data-description")) {
              title += img.attr("data-description");
            }
            return title;
          },
        },
      });
    });
  }

  function scrollToHash(hash) {
    var anchor = "";
    if (hash) {
      anchor = "#" + hash;
    } else {
      if (window.location.hash) {
        anchor = window.location.hash;
      }
    }

    var anchorElem = $(anchor);
    if (anchorElem.length === 0) {
      return;
    }

    if (anchor || anchor !== "") {
      var searchPattern = new RegExp("^#c", "i");
      var offsetTop = anchorElem.offset().top;
      if (searchPattern.test(anchor)) {
        if (anchorElem.hasClass("ctype-ce_accordion_inline")) {
          anchorElem.find(".panel-0 .b-panel__title").addClass("clicked");
          window.location.hash = "";
          window.history.replaceState(
            "",
            document.title,
            window.location.pathname
          );
        }
        if (anchorElem.hasClass("klapper")) {
          anchorElem.find(".b-panel__title").addClass("clicked");
          window.location.hash = "";
          window.history.replaceState(
            "",
            document.title,
            window.location.pathname
          );
        }
        $("html, body")
          .stop()
          .animate({ scrollTop: offsetTop - 10 }, "slow");
      }
    }
  }

  $(".rsbtn_play").on("click", function (e) {
    setTimeout(function () {
      $(".b-panel__title").addClass("clicked");
      $(".long-content-section__line").fadeToggle(300);
      $(".btn_toggle-content").toggleClass("clicked").find("span").toggle();
      $(".rsbtn_closer").on("click", function (e) {
        e.preventDefault();
        window.location.reload(false);
      });
    }, 500);
  });

  $("a[href]").on("click", function (e) {
    var classList = e.currentTarget.classList;
    var href = $(this).attr("href");
    var searchPattern1 = new RegExp("^" + window.location.pathname, "i");
    var searchPattern2 = new RegExp("#c", "i");
    var hasToggle = false;

    classList.forEach((item) => {
      if (item.indexOf("toggle") !== -1) hasToggle = true;
    });

    if (!hasToggle) {
      if (href.charAt(0) === "#" && href.length > 1) {
        e.preventDefault();
        scrollToHash(href.substring(1));
        return;
      }
    }

    if (window.location.pathname !== "/") {
      if (searchPattern1.test(href) && searchPattern2.test(href)) {
        var array = href.split("#");
        // window.location.hash = array[1];
        if (array[0] === window.location.pathname) {
          e.preventDefault();
          $(".b-panel__title.clicked").removeClass("clicked");
          scrollToHash(array[1]);
        }
      }
    }
  });

  scrollToHash();
})(jQuery);

function initMap() {
  var pos = { lat: 48.715509, lng: 8.745031 };
  var map = new google.maps.Map(document.getElementById("map"), {
    zoom: 12,
    center: pos,
    disableDefaultUI: true,
  });
  var marker = new google.maps.Marker({
    position: pos,
    map: map,
  });
}
